// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRecordErrorDto } from './IRecordErrorDto';
import {
    IRecordErrorDtoFromJSON,
    IRecordErrorDtoFromJSONTyped,
    IRecordErrorDtoToJSON,
    IRecordErrorDtoToJSONTyped,
} from './IRecordErrorDto';

/**
 * 
 * @export
 * @interface IRecordDto
 */
export interface IRecordDto {
    /**
     * 
     * @type {number}
     * @memberof IRecordDto
     */
    record_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRecordDto
     */
    json_data?: string;
    /**
     * 
     * @type {Array<IRecordErrorDto>}
     * @memberof IRecordDto
     */
    record_errors?: Array<IRecordErrorDto>;
    /**
     * 
     * @type {Date}
     * @memberof IRecordDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IRecordDto
     */
    processed_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IRecordDto
     */
    processing_status?: IRecordDtoProcessingStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IRecordDto
     */
    is_valid?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IRecordDtoProcessingStatusEnum {
    INITIATED = 'INITIATED',
    VALIDATED = 'VALIDATED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
    SKIPPED = 'SKIPPED',
    DECLINED = 'DECLINED'
}


/**
 * Check if a given object implements the IRecordDto interface.
 */
export function instanceOfIRecordDto(value: object): value is IRecordDto {
    return true;
}

export function IRecordDtoFromJSON(json: any): IRecordDto {
    return IRecordDtoFromJSONTyped(json, false);
}

export function IRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'record_id': json['record_id'] == null ? undefined : json['record_id'],
        'json_data': json['json_data'] == null ? undefined : json['json_data'],
        'record_errors': json['record_errors'] == null ? undefined : ((json['record_errors'] as Array<any>).map(IRecordErrorDtoFromJSON)),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'processed_at': json['processed_at'] == null ? undefined : (new Date(json['processed_at'])),
        'processing_status': json['processing_status'] == null ? undefined : json['processing_status'],
        'is_valid': json['is_valid'] == null ? undefined : json['is_valid'],
    };
}

export function IRecordDtoToJSON(json: any): IRecordDto {
    return IRecordDtoToJSONTyped(json, false);
}

export function IRecordDtoToJSONTyped(value?: IRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'record_id': value['record_id'],
        'json_data': value['json_data'],
        'record_errors': value['record_errors'] == null ? undefined : ((value['record_errors'] as Array<any>).map(IRecordErrorDtoToJSON)),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'processed_at': value['processed_at'] == null ? undefined : ((value['processed_at']).toISOString()),
        'processing_status': value['processing_status'],
        'is_valid': value['is_valid'],
    };
}

